<template lang="pug">
.v-input__control
  .v-input__slot
    label.toggle__track(:class="{ 'active': isActive, 'toggle__track--disabled': disabled }" :style="cssProps")
      input(type="checkbox" :disabled="disabled" v-model="modelValue" @change="isActive = !isActive"  :value="value" :true-value="trueValue" :false-value="falseValue")
      span.toggle__knob(:class="{ 'toggle__knob--disabled': disabled }")
    label.ml-2.pb-1.v-label.theme--light(style="left: 0px; right: auto; position: relative;") {{ label }}
</template>

<script>
export default {
  name: 'YSwitch',
  model: {
    prop: 'inputValue',
    event: 'change',
  },
  props: {
    value: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inputValue: {
      default: null
    },
    trueValue: {
      default: true
    },
    falseValue: {
      default: false
    },
    label: {
      default: '',
      type: String
    },
    color: {
      default: '#30C183',
      type: String
    }
  },
  data () {
    return {
      isActive: false
    }
  },
  computed: {
    modelValue: {
      get() {
        return this.inputValue
      },
      set(newValue) {
        this.$emit('change', newValue);
      }
    },
    cssProps () {
      return {
        '--color': this.color
      }
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler () {
        if (Array.isArray(this.modelValue)) {
          this.isActive = this.modelValue.includes(this.value)
        } else {
          this.isActive = Boolean(this.modelValue)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
$toggle__track-height: 32px;
$toggle__track-width: 52px;
$toggle__knob-padding: 2px;

.toggle__track {
  vertical-align: middle;
  user-select: none;
  cursor: pointer;
}
.toggle__track input[type="checkbox"] {
  opacity: 0;
  position: absolute;
  width: 1px;
  height: 1px;
}
.toggle__track .toggle__knob {
  display: inline-block;
  height: $toggle__track-height;
  border-radius: $toggle__track-height / 2;
  width: $toggle__track-width;
  background: rgba(143, 155, 179, 0.16);
  box-shadow: 0 0 1px rgba(143, 155, 179, 0.16);
  position: relative;
  margin-left: 10px;
  transition: all .25s;
}
.toggle__track .toggle__knob::after,
.toggle__track .toggle__knob::before {
  content: "";
  position: absolute;
  display: block;
  height: $toggle__track-height - $toggle__knob-padding * 2;
  width: $toggle__track-height - $toggle__knob-padding * 2;
  border-radius: 50%;
  left: $toggle__knob-padding;
  top: $toggle__knob-padding;
  transform: translateX(0);
  transition: .15s cubic-bezier(.25,.8,.5,1);
}
.toggle__track .toggle__knob::after {
  background: #ffffff;
  box-shadow: 0 0 1px #ffffff;
}
.toggle__track .toggle__knob::before {
  opacity: 0;
}

.active .toggle__knob {
  background: var(--color);
  box-shadow: 0 0 1px var(--color);
}

.active .toggle__knob::after,
.active .toggle__knob::before{
  transform:translateX(-1px);
}

.active .toggle__knob::after {
  left: 23px;
  background: #ffffff;
}

.toggle__knob.toggle__knob--disabled {
  border: 1px solid rgba(143, 155, 179, 0.32);
  box-shadow: none;
}

.toggle__track.toggle__track--disabled .toggle__knob::before,
.toggle__track.toggle__track--disabled .toggle__knob::after {
  left: $toggle__knob-padding - 1;
  top: $toggle__knob-padding - 1;
}

.toggle__track.toggle__track--disabled .toggle__knob::after {
  background: rgba(143, 155, 179, 0.48)
}

.active.toggle__track--disabled .toggle__knob {
  background: rgba(143, 155, 179, 0.16);
  box-shadow: none;
}

.active.toggle__track--disabled .toggle__knob::after {
  left: 22px;
  background: rgba(143, 155, 179, 0.48);
}
</style>
